// extracted by mini-css-extract-plugin
export default {"products":"Sv-z","card":"Tv-z","oosMessaging":"Uv-z"};